export const faqData = [
  {
    id: 1,
    title: 'How do I refer a friend?',
    content:
      'To invite a friend, you can share the referral link through email, text, or social media.',
  },
  {
    id: 2,
    title: 'What is a collectible Planet reward?',
    content:
      'It’s a digital collectible prize, or an NFT, that a Solartrip customer receives after completing a respective action.',
  },
  {
    id: 3,
    title: 'When will I receive my referral Planet collectibles?',
    content:
      'Your referral Planet collectibles will be generated after 5 successful sign-ups or a completed respective activity of your friends. Please be aware that crafting your one-of-a-kind Planet involves a meticulous and creative process, driven by our genuine AI, which may take some time.',
  },
  {
    id: 4,
    title: 'What can I do with my Planets collectibles?',
    content:
      'You can assemble your Planets in a planetary system, showcase them on social media, or add them to your digital wallet.',
  },
  {
    id: 5,
    title: 'Can I refer friends who already have the Solartrip app?',
    content:
      'Yes, you can refer friends who have the app already installed with a referral link to proceed with their first app order or crypto transaction.',
  },
  {
    id: 6,
    title: `Where can I review the current status of the rewards I've earned through referrals?`,
    content: 'You can check your status in your Profile, in the My collectibles section.',
  },
];
